<template>
  <div class="tags">
    <a class="tag is-lowercase" v-for="tag in tags" :key="tag" @click="goToTag(tag)">
      <text-highlight :queries="highlight || ''" :caseSensitive="false">#{{tag}}</text-highlight>
    </a>
  </div>
</template>

<script>
export default {
  name: "Tags",
  props: ["tags", "highlight"],
  methods: {
    goToTag(tag) {
      this.$router.push({
        name: "searchresults",
        query: { q: tag }
      });
    }
  }
};
</script>
